import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../atoms/button/button.component';

export type StepperActionBarLayout = 'start' | 'between' | 'last-step';

@Component({
  selector: 'htx-stepper-action-bar',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './stepper-action-bar.component.html',
  styleUrl: './stepper-action-bar.component.scss'
})
export class StepperActionBarComponent {
  /**
   * Layout type:
   * 'start': Only next button on right (50% width with placeholder on left)
   * 'between': Both previous and next buttons (50/50 split, both full width)
   * 'last-step': Single centered button (50% width)
   */
  layout = input<StepperActionBarLayout>('start');

  /**
   * Gap between buttons in rem units
   */
  gap = input<number>(1);

  /**
   * Whether to show a divider line above the action bar
   */
  showDivider = input<boolean>(true);

  /**
   * Emitted when the "previous" button is clicked
   */
  previous = output<void>();

  /**
   * Emitted when the "next" button is clicked
   */
  next = output<void>();

  /**
   * Emitted when the "last step" button is clicked
   */
  lastStep = output<void>();

  /**
   * Label for the previous button
   */
  previousLabel = input<string>('Zurück');

  /**
   * Label for the next button
   */
  nextLabel = input<string>('Weiter');

  /**
   * Whether the previous button is disabled
   */
  previousDisabled = input<boolean>(false);

  /**
   * Whether the next button is disabled (also used for centered button)
   */
  nextDisabled = input<boolean>(false);

  /**
   * Label for the last-step button (used in 'last-step' layout)
   */
  lastStepLabel = input<string>('Fortfahren');

  onPrevious() {
    this.previous.emit();
  }

  onNext() {
    this.next.emit();
  }

  onLastStep() {
    this.lastStep.emit();
  }
}
